export const getApiErrorMessage = error => {
	if (typeof error === "string") {
		return error;
	}

	if (error && Array.isArray(error)) {
		return error.join(", ");
	}

	return null;
};

export const getFormErrorMessages = error => {
	if (typeof error === "string") {
		return [error];
	}

	if (error && error.message) {
		return [error.message];
	}

	if (error && Array.isArray(error)) {
		return error;
	}

	return null;
};
